// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import {Link} from 'react-router-dom';
  import { withRouter } from 'react-router';
  import moment from 'moment';
  import Avatar from 'material-ui/Avatar';
  import {CardMedia} from 'material-ui/Card';
  import Checkbox from 'material-ui/Checkbox';
  import IconButton from 'material-ui/IconButton';
  import AddIcon from 'material-ui/svg-icons/content/select-all';
  import BlockIcon from 'material-ui/svg-icons/content/block';
import { start } from 'pretty-error';
  
  
  class EditEvent extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        id: props.match.params.id,
        event: {
          id: "",
          name: "",
          venue: "",
          game_type: 2,
          start_date: '',
          age_category: '',
          registration_end: '',
          banner: '',
          registration_amount: '',
          description: "",
        },
        venues: [],
        game_types: [],
        age_categories: [],
  
      };
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleEndDateChange = this.handleEndDateChange.bind(this);
      this.handleStartDateChange = this.handleStartDateChange.bind(this);
      this.handleFile = this.handleFile.bind(this);
    }
  
  
    componentDidMount() {
      this.getEvent();
    }
  
    getEvent() {
       const url = `${getLocationOrigin()}/eagleeye/${this.state.id}/get_details_for_edit_event/`;
       const options = {...defaultOptions};
  
       fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({ venues: data.venues,
           game_types: data.game_type,
           event: data.event,
           age_categories: data.age_category,
           }))
         .catch(error => error);
    }
  
    postEditedEvent(data, props) {
      const url = `${getLocationOrigin()}/eagleeye/edit_event/`;
      const options = {...defaultOptions};
      var formData = new FormData();
      for(var name in data) {
        formData.append(name, data[name]);
      }
      for(var start_date in data) {
        formData.append(start_date, data[start_date]);
      }
      for(var registration_end in data){
          formData.append(registration_end, data[registration_end]);
      }

      options['method'] = 'post';
      options['body'] = formData;
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(function(response){                      // first then()
            alert(response.message);
            props.history.goBack();
        })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }
  
    handleStartDateChange(event){
      var new_selected_one =  Object.assign({}, this.state.event);
      new_selected_one['start_date'] = event.target.value
      this.setState({event: new_selected_one});
    }
  
    handleEndDateChange(event){
      var new_selected_one =  Object.assign({}, this.state.event);
      new_selected_one['registration_end'] = event.target.value
      this.setState({event: new_selected_one});
    }
  
    handleFile(selectorFiles: FileList){
      var new_selected_one =  Object.assign({}, this.state.event);
      console.log('Fileeeee');
      console.log(selectorFiles);
      new_selected_one['banner'] = selectorFiles[0]
      this.setState({event: new_selected_one});
    }
  
    handleChange(event) {
      const name = event.target.name;
      var new_selected_one = Object.assign({}, this.state.event);
      new_selected_one[name] = event.target.value
      console.log(new_selected_one);
      this.setState({event: new_selected_one});
    }
    
  
    handleSubmit(event) {
      event.preventDefault();
      console.log('Submit');
      console.log(this.state.event);
      this.postEditedEvent(this.state.event, this.props);
      console.log('post');
      console.log(this.state);
    }

  
    render() {
      return(
        <div style={styles.container}>
          <div className="row col-md-8 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12">
              <h3 style={{textAlign:'center'}}>Edit Event</h3>
            </div>
            <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
  
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Event Name
                </div>
                <input type="text"
                  style={styles.input}
                  name="name"
                  value={this.state.event.name}
                  onChange={this.handleChange}/>
              </div>
  
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Venue
                </div>
                <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.event.venue}
                  onChange={this.handleChange}>
                  {
                    this.state.venues.map((x, index) => (
                    <option key={x.id} value={x.id}>{x.name}</option>
                    ))
                  }
                </select>
              </div>
  
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Game type
                </div>
                <select name="game_type" style={styles.item_body} className="col-md-6"
                  value={this.state.event.game_type} onChange={this.handleChange}>
                  {
                    this.state.game_types.map((x, index) => (
                    <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                    ))
                  }
                </select>
              </div>
  
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Start Date(DD/MM/YYYY)
                </div>
                
                <input type='text' style={styles.input} name="start_date" value={this.state.event.start_date}  onChange={this.handleStartDateChange}/>
              </div>
  
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Registration End Date(DD/MM/YYYY)
                </div>
                <input type='text' style={styles.input} name="start_date" value={this.state.event.registration_end}  onChange={this.handleEndDateChange}/>
              </div>
  
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Age Category
                </div>
                <select name="age_category" className="col-md-6" style={styles.item_body} value={this.state.event.age_category}
                  onChange={this.handleChange}>
                  {
                        this.state.age_categories.map((age_category, index) => (
                        <option key={age_category.id} value={age_category.id}>{age_category.name}</option>
                        ))
                        }
                </select>
              </div>
  
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Current Banner
                </div>
                <div className="col-md-6" style={styles.input}>
                  <CardMedia>
                    <img src={`https://api.sporthood.in${this.state.event.banner}`} alt=""/>
                  </CardMedia>
                </div>
              </div>
  
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  New Banner*
                </div>
                <input type="file" style={styles.input} style={{float:'left'}} name="banner" onChange={ (e) => this.handleFile(e.target.files) }/>
              </div>
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Event Amount
                </div>
                <input type="text"
                  style={styles.input}
                  name="registration_amount"
                  value={this.state.event.registration_amount}
                  onChange={this.handleChange}/>
              </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Event Description 
                </div>
                <textarea rows="4" cols="33" style={styles.input} id="description" name="description" placeholder={this.state.event.description}
                  onChange={this.handleChange}>
                  {this.state.event.description}
                  </textarea>
              </div>
  
              <div style={styles.button_submit} className="col-md-12">
                <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                  color:'#ffffff'}}/>
              </div>
            </form>
          </div>
        </div>
      );
    }
  }
  
  export default EditEvent;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editEvent/index.js